<template>
	<div>
		<div id="panel-4" class="panel">
			<div class="panel-hdr ">
				<h2>
					{{__t('LIST')}} <span class="fw-300"><i>{{__t('ORDERS')}}</i></span>
				</h2>

				<div class="panel-toolbar">
					<button class="btn btn-panel waves-effect waves-themed"
							data-action="panel-fullscreen"
							data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen">
					</button>
				</div>
			</div>

			<div class="panel-container show">
				<div class="panel-content">
					<div class="filter_block mb-3">
						<filter_head></filter_head>
					</div>

					<b-skeleton-table
						v-if="is_load"
						:rows=this.cur_records :columns="2" :hide-header=true
						:table-props="{ bordered: false, striped: true }"
					>
					</b-skeleton-table>


					<div class="inbox_vue_list" v-if="!is_load">

						<div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                key="up"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
						</div>


						<b-table
							v-if="rows.length > 0"
							:tbody-tr-class="rowClass"
							striped class="table-responsive-xl resolution_table" :items="rows" :fields="fields">

							<!-- header fields -->
							<template v-slot:head(id)="data">
								<div class="status_info" style="max-width: 50px">
									{{__t('O_STATUS')}}
								</div>
							</template>

                            <template v-slot:head(order_export_provider)="data">
                                <div class="status_info" style="max-width: 50px">
                                    {{__t('O_EXP_IC')}}
                                </div>
                            </template>

							<template v-slot:head(glovo_restaurant)="data">
								<div class="status_info" style="max-width: 50px">
                                    {{__t('O_RESTAURANT')}}
								</div>
							</template>

							<template v-slot:head(uniq)="data">
                                <grid_list
                                    :list_ordering="'uniq'"
                                    :field_name="__t('UNIQ')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
							</template>

							<template v-slot:head(cost)="data">
                                <grid_list
                                    :list_ordering="'cost'"
                                    :field_name="__t('COST')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
							</template>

							<template v-slot:head(added)="data">
								{{__t('DATE')}}
							</template>

							<!-- body draw -->
                            <template  v-slot:cell(can_pdf)="data">
                                <a class="pdf_link cursor-pointer" target="_blank" :href='"/internal/v1/catalog/orders/" + data.item.id + "/pdf"'>
                                    <div class='icon-stack fs-xxl mt-3' >
                                        <i class="base base-19 icon-stack-3x opacity-100 color-primary-900"></i>
                                        <i class="fal fa-file-pdf icon-stack-1x opacity-100 color-white"></i>
                                    </div>
                                </a>
                            </template>


                            <template v-slot:cell(order_export_provider)="data">
                                <div class="provider_img" v-if="obj_to_null(data.item.aggregator)">
                                    <div class="icon">

                                        <img
                                            v-if="obj_to_null(data.item.aggregator.icon_url)"
                                            :src="data.item.aggregator.icon_url"
                                            class="order_prov_image"
                                            alt=""
                                        >

                                        <i
                                            class="fal fa fa-file-o fa-file"
                                            v-else
                                        ></i>

                                    </div>
                                </div>
                            </template>

							<template v-slot:cell(uniq)="data">
								<div class="">

                                    <div class="d-flex flex-start w-100 fs-xl mb-2" >
                                        <div class="icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer" v-on:click="open_order(data.item)">
                                            <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                                            <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                                        </div>
                                        {{ data.item.order_code }}
                                    </div>

                                    <div class="d-flex flex-start w-100 prov_block">

                                        <div v-if="data.item.is_delivery_provider">
                                            <div class="small badge border border-success">
                                                {{ data.item.pos.type }}

                                            </div>
                                            <span class="pl-2 pr-2">
                                                    -->
                                                </span>
                                            <div class="small badge border border-warning">
                                                {{ data.item.provider_in_txt }}
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="small badge border border-success">
                                                {{ data.item.provider_in_txt }}
                                            </div>
                                            <span class="pl-2 pr-2">
                                                    -->
                                                </span>
                                            <div class="small badge border border-warning">
                                                {{ data.item.pos.type }}
                                            </div>
                                        </div>


                                    </div>
                                </div>
							</template>

							<template v-slot:cell(id)="data">
								<div class="small badge p-2" :class="get_order_class(data.item)"
									 style="max-width: 200px">
									{{ build_order_status(data.item) }}
								</div>
							</template>

							<template v-slot:cell(glovo_restaurant)="data">

                                <div class="d-flex flex-start w-100 mb-2" >
                                    <!--
                                    <div class="provider_img mr-2" v-if="obj_to_null(data.item.order_export_provider)">
                                        <div  class="icon">
                                            <i class="fal fa fa-file-o fa-file" v-if="!obj_to_null(data.item.order_export_provider.icon)"></i>
                                            <span
                                                class="order_prov_image"
                                                v-if="obj_to_null(data.item.order_export_provider.icon)"
                                                v-html="data.item.order_export_provider.icon">

                                            </span>
                                        </div>
                                    </div>
                                    -->

                                    <div  v-if="obj_to_null(data.item.location)">
                                        <div class="small badge border border-success">
                                            {{ data.item.location.title }} -
                                            {{ data.item.location.uniq_id }}
                                        </div>
                                    </div>
                                </div>


								<div>
									<div class="small badge border border-warning" style="max-width: 200px"
										 v-if="obj_to_null(data.item.pos_rest)">
										{{ data.item.pos_rest.title }}
									</div>
									<div сlass="small badge border border-danger" v-else>
										Не знайдено
									</div>
								</div>
							</template>

							<template v-slot:cell(added)="data">
								<div>
									<div class=" badge badge-info">
										IN -> {{ data.item.times_data.market.added_human }}
									</div>
								</div>

								<div>
									<div class=" badge badge-success">
										DELIVERY ->  {{ data.item.times_data.market.estimate_human }}
									</div>
								</div>

							</template>

							<template v-slot:cell(cost)="data">
								<div class="prod_price bold color-primary-900 mt-4">
									{{ new Intl.NumberFormat('ru-RU').format(parseFloat(data.item.price)) }}
									<span class="woocommerce-Price-currencySymbol  fs-sm">
                                        {{data.item.price | getCurrency}}
                                    </span>
								</div>
							</template>
						</b-table>

						<div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                key="down"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
						</div>
					</div>
				</div>
			</div>
		</div>

		<order_modal></order_modal>
		<order_modal event_name="order_modal_secondary" :show_client_tab="false"></order_modal>
	</div>
</template>

<script>
import Filter_head from "./filter_view/filter_head";
import {createHelpers} from 'vuex-map-fields';

import Grid_list from "../sys/list/grid_list.vue";
import Pagination_list from "../sys/list/pagination_list.vue";




import {mapGetters} from "vuex";
import Order_modal from "./order/order_modal";
import Sys_pagination from "../../sys/pagination/pagination";


export default {
	name: "orders.vue",
	components: {
        Pagination_list,
        Grid_list,

		Sys_pagination,
		Order_modal,
		Filter_head
	},
	data() {
		return {
			rows: [],
			is_load: true,
			is_check_all: false,
			is_filter_work: false,
			cur_records: 35,
			active_items: [],

            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },

            list: {
                direction: "DESC",
                ordering: "added",
                start: 0
            },

            filter: {
                search: "",
                rest_id: 0,
                provider_id: 0,
            },


			fields: [
				{
					key: 'id',
					label: '',
					class: 'text-left vl-middle m_width_90'
				},
                {
                    key: 'order_export_provider',
                    label: '',
                    class: 'text-left m_width_50'
                },
				{
					key: 'uniq',
					label: '',
					class: 'text-left'
				},



				{
					key: "glovo_restaurant",
					label: '',
					class: 'text-left'
				},

				{
					key: 'added',
					label: '',
					class: 'text-center'
				},
				{
					key: 'cost',
					label: this.__t('ORDER.PRICE'),
					class: 'text-center'
				},

                {
                    key: 'can_pdf',
                    label: '',
                    class: 'text-left'
                },

			],
		}
	},

    created() {
	    EventBus.$on('new_order_in',this.try_reload_orders);
		EventBus.$on("orders_reload", this.load_items);

        EventBus.$on("clean_orders_filter", this.clean_order_filter);
        EventBus.$on("search_orders_called", this.search_work);


		EventBus.$on("orders_change_state", this.change_state);
        EventBus.$on("filter_order_select_change",this.filter_select);

	},

	mounted() {
        this.load_items();
		//this.$store.dispatch('orders/LOAD_STATES', this.current_state);
	},

	methods: {

        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },

        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },


        build_order_status(order) {
            if (order.hasOwnProperty("reject_log_count")) {
                if (parseInt(order.reject_log_count) > 0) {
                    return 'reject';
                }
            }
            return order.order_status;
        },

        clean_order_filter() {

            this.filter = {
                search: "",
                provider_id: 0,
                rest_id: 0,
            };

            this.list = {
                direction: "DESC",
                ordering: "added",
                start: 0
            };
            this.load_items();
        },

        get_order_class(order) {
            let status = order.order_status;
            if(order.hasOwnProperty("reject_log_count")) {
                if(parseInt(order.reject_log_count) > 0) {
                    status = 'cancel';
                }
            }

            if (status === 'finish') {
                return 'badge-success';
            }
            if (status === 'new') {
                return 'badge-info';
            }

            if (status === 'error' || status === 'cancel') {
                return 'badge-danger';
            }

            if (status === 'wait') {
                return 'badge-dark';
            }
        },

        search_work(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },

        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },


        try_reload_orders() {
            try {
                let start_pagi = this.list.start;
                if(parseInt(start_pagi) === 0) {
                    this.load_items();
                }
            }
            catch (e) {
            }
        },

        async load_items() {
            this.rows = [];
            this.is_load = true;

            await api.post('/internal/v1/catalog/orders',{
                list: this.list,
                filter: this.filter
            })
                .then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.rows = data.data;

                        if (data.message?.pagination) {
                            this.pagination = data.message.pagination;
                        }
                    }
                })
                .catch(({response}) => {
                    this.is_load = false;
                    this.rows = [];
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    })
                });
        },

		open_order(order) {
			EventBus.$emit("order_modal", order);
		},


		rowClass(item) {
			if (!item) return;
			return item.class;
		},

	},

	computed: {

		...mapGetters({
			'user': "user/getUser",
		}),

	}
}
</script>

<style scoped>
.prod_price {
	font-size: 20px;
}
.order_prov_image {
    display: block;
    width: 40px;
    height: 40px;
    object-fit: contain;
}
</style>
